{
  "actions": {
    "back": "Terug",
    "close": "Sluiten",
    "minimize": "Minimaliseren",
    "maximize": "Maximaliseren",
    "restore": "Herstellen"
  },
  "home": {
    "title": "Home",
    "role": "Product Designer & Developer",
    "role_pdf": "Designer & Developer",
    "pitch": "Ik maak ingewikkelde digitale dingen begrijpelijk en bruikbaar. Ik zie waar een flow vastloopt, stel de juiste vragen en bouw door tot het voor mensen én techniek klopt.",
    "skills": {
      "product_design": "Product Design",
      "ux_research": "UX Research",
      "frontend": "Frontend Dev",
      "websites_apps": "Websites & Apps",
      "design_systems": "Design Systems",
      "ai_workflows": "AI Workflows"
    },
    "available": "Beschikbaar voor projecten en vaste rollen",
    "cta_work": "Bekijk mijn werk",
    "cta_contact": "Neem contact op"
  },
  "work": {
    "title": "Work",
    "heading": "Geselecteerd Werk",
    "filters": {
      "all": "Alles",
      "apps": "Applicaties",
      "video": "AI Video",
      "design": "Design"
    },
    "back": "Terug",
    "role": "Rol",
    "tech": "Technologie",
    "results": "Resultaten",
    "intention": "Intentie",
    "process": "Proces",
    "outcome": "Resultaat",
    "gallery": "Galerij",
    "view_case": "Bekijk case study",
    "cta_title": "Herken je dit in jouw product?",
    "cta_button": "Zullen we sparren?"
  },
  "about": {
    "title": "Over Mij",
    "heading": "Het hele plaatje",
    "intro": "Ik vertaal vage ideeën en losse systemen naar producten die mensen snappen. Als iets onnodig ingewikkeld is, wil ik weten waar het knelt — en het vervolgens werkbaar maken.",
    "approach_title": "Hoe ik werk",
    "approach": "Ik begin bij wat iemand echt moet kunnen doen. Daarna haal ik weg wat afleidt, maak ik snel iets tastbaars en test ik of de logica klopt. Design en techniek horen daarbij niet in aparte hokjes.",
    "capabilities_title": "Mijn pad & focus",
    "capabilities": {
      "ux": "UX als basis (sinds 2018) — Begonnen bij de gebruiker. Hoe denken mensen? Waar haken ze af? Wat voelt logisch en wat niet?",
      "tech": "Technisch inzicht — Frontend development om precies te snappen hoe dingen gebouwd worden, zodat design en techniek echt op elkaar aansluiten.",
      "ai": "AI als versneller — Ik gebruik AI niet als trucje, maar om sneller te onderzoeken, prototypen en workflows slimmer te maken. Van prompt engineering tot integraties die echt iets opleveren.",
      "now": "Breed inzetbaar — Van websites en apps tot wireframes, mockups en dashboards. Ik doe het uitzoekwerk, maak het concreet en bouw door tot het voor de eindgebruiker klopt.",
      "drive": "Wat mij drijft — Systemen waar anderen liever niet aan beginnen. Ik zoek uit hoe het zit, bouw een eerste versie en blijf schaven tot het klopt."
    }
  },
  "resume": {
    "title": "CV",
    "download": "Download CV (.pdf)",
    "experience": "Werkervaring",
    "education": "Opleiding",
    "skills": "Vaardigheden",
    "learning": "Doorlopende ontwikkeling",
    "learning_practice_title": "Ik leer door te bouwen",
    "learning_focus": "Ik leer het snelst door iets te maken. Nieuwe AI-tools en frameworks probeer ik in eigen projecten, kijk waar ze breken en bouw dan verder tot ik weet wat er echt werkt.",
    "projects": "Uitgelicht project",
    "project_meester_title": "Meester djay",
    "project_meester_subtitle": "Adaptief leerplatform voor groep 6–8",
    "project_meester_meta": "Zelfstandig productproject / Actueel",
    "project_meester_description": "Ontwikkelde een adaptief oefenplatform met een mastery-based engine, multi-role portalen en AI-assisted engineering - van leerervaring en UX tot technische architectuur.",
    "project_meester_capability": "Van concept en UX tot adaptieve logica, contentvalidatie en technische architectuur.",
    "project_meester_metric_subjects": "10 vakgebieden",
    "project_meester_metric_questions": "263 vraagfamilies",
    "project_meester_metric_levels": "16 niveaustappen",
    "freelance_role": "Freelance Product Designer & Developer",
    "freelance_company": "MvlCreative — Almere",
    "freelance_period": "2021 — Heden",
    "freelance_description": "Ontwerp en bouw digitale producten die complexe processen helder en intuïtief maken. Van UX-strategie en design systems tot frontend development, LLM-integraties en AI-workflows.",
    "webheld_role": "Web Developer",
    "webheld_company": "Webheld — Baarn",
    "webheld_period": "2020 — 2021",
    "webheld_description": "Bouwde en optimaliseerde WordPress- en Magento-websites en webshops, met focus op stabiele oplevering, technische kwaliteit, SEO en gebruiksvriendelijke interfaces.",
    "aim_role": "Web Developer",
    "aim_company": "Aim — Badhoevedorp",
    "aim_period": "2020",
    "aim_description": "Levering van websites van ontwerp tot livegang en het doorontwikkelen van WordPress-omgevingen voor een consistente, onderhoudbare digitale basis.",
    "tweak_role": "Service Desk",
    "tweak_company": "Tweak — Almere",
    "tweak_period": "2019 — 2020",
    "tweak_description": "Vertaalde technische klantvragen naar heldere oplossingen via analyse, troubleshooting en zorgvuldige opvolging — met aandacht voor een goede gebruikerservaring.",
    "more_coming": "Meer werkervaring wordt binnenkort toegevoegd."
  },
  "contact": {
    "title": "Contact",
    "heading": "Laten we kennismaken",
    "phone_label": "Telefoon",
    "location": "Almere, Nederland",
    "location_label": "Locatie",
    "availability": "Nederland + remote. Open voor projecten en vaste rollen.",
    "status": "Open voor projecten en vaste rollen",
    "cta_call": "Plan een videocall",
    "social_label": "Social",
    "status_label": "Status"
  },
  "boot": {
    "loading": "Creativiteit laden...",
    "design_systems": "Design systems initialiseren...",
    "connecting_ai": "AI verbinden...",
    "ready": "Gereed."
  },
  "command": {
    "placeholder": "Zoek of navigeer...",
    "projects": "Projecten",
    "navigation": "Navigatie",
    "settings": "Instellingen"
  }
}